// These are local record identifiers, never return URLs or credentials.
export const validTicketNumber = (value) => /^AK-[A-Za-z0-9_-]{1,80}$/.test(value || '') ? value : null;

export const ticketListState = (search) => {
  const params = new URLSearchParams(search);
  const page = Number(params.get('page'));
  return {
    search: (params.get('search') || '').slice(0, 200),
    status: (params.get('status') || '').slice(0, 40),
    priority: (params.get('priority') || '').slice(0, 20),
    unread: params.get('unread') === 'true',
    page: Number.isSafeInteger(page) && page > 0 ? page : 1,
  };
};

export const ticketReturnPath = (portalBasePath, ticket, search = '') => {
  const number = validTicketNumber(ticket);
  if (portalBasePath !== '/app/ecommerce' || !number) return null;
  const state = ticketListState(search);
  const params = new URLSearchParams({ ticket: number });
  for (const [key, value] of Object.entries(state)) {
    if (value && !(key === 'page' && value === 1)) params.set(key, String(value));
  }
  return `${portalBasePath}?${params}`;
};
